module.exports = __webpack_public_path__ + "img/DW365-232.80e3a9de.jpg";